import { Status } from 'civic-champs-shared/api/hooks/fetchRefactoredSchema'
import useFetchRefactored from 'civic-champs-shared/api/hooks/useFetchRefactored'
import { useCallback } from 'react'
import { useCurrentOrg } from 'auth/hooks'
import { Person } from 'civic-champs-shared/question-sets/types'
import { AddUserPayload } from 'civic-champs-shared/core/add-person/types'

const useAddChampion = (): [(payload: AddUserPayload) => Promise<Person>, Status<Person>] => {
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<Person>({
    successMessage: 'Champion added successfully',
    errorMessage: 'Error adding champion',
  })

  const addChampion = useCallback(
    (payload: AddUserPayload) => {
      return request({
        method: 'post',
        url: `/organizations/${organization.id}/volunteers`,
        config: {
          headers: {
            'X-Api-Version': '2020-01-17',
          },
          body: payload,
        },
      })
    },
    [organization.id, request],
  )

  return [addChampion, status]
}

export default useAddChampion
